import React from 'react';
import { FiAlertCircle, FiCalendar } from 'react-icons/fi';
import { C } from './tokens';

export const Sh = ({ h = 20, w = '100%', r = 6, mb = 0 }) => (
  <div style={{ height:h, width:w, borderRadius:r, marginBottom:mb,
    background:'linear-gradient(90deg,#F1F5F9 25%,#E2E8F0 50%,#F1F5F9 75%)',
    backgroundSize:'400px 100%', animation:'rptShimmer 1.4s infinite' }}/>
);

export const Pill = ({ label, bg, color, border }) => (
  <span style={{ display:'inline-flex', alignItems:'center', padding:'2px 10px', borderRadius:999,
    fontSize:11, fontWeight:700, background:bg, color, border:`1px solid ${border||bg}`, whiteSpace:'nowrap' }}>
    {label}
  </span>
);

export const Kpi = ({ label, value, icon, iconBg, iconColor, accent, loading, sub, onClick }) => (
  <div onClick={onClick} style={{ background:C.white, borderRadius:12, border:`1px solid ${C.border}`,
    padding:'16px 18px', boxShadow:'0 2px 6px rgba(13,59,94,0.06)', position:'relative', overflow:'hidden',
    cursor: onClick ? 'pointer' : 'default' }}>
    <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:accent, borderRadius:'12px 12px 0 0' }}/>
    <div style={{ width:36, height:36, borderRadius:9, background:iconBg,
      display:'flex', alignItems:'center', justifyContent:'center', color:iconColor, marginBottom:10 }}>{icon}</div>
    {loading
      ? <Sh h={28} w="50%" mb={6}/>
      : <div style={{ fontSize:24, fontWeight:800, color:C.t1, letterSpacing:'-0.04em', lineHeight:1, marginBottom:5 }}>{value ?? '—'}</div>}
    <div style={{ fontSize:12, fontWeight:600, color:C.t3 }}>{label}</div>
    {sub && !loading && <div style={{ fontSize:11, color:C.t4, marginTop:3 }}>{sub}</div>}
  </div>
);

export const Card = ({ title, icon, badge, children, headerRight }) => (
  <div style={{ background:C.white, borderRadius:12, border:`1px solid ${C.border}`,
    overflow:'hidden', boxShadow:'0 2px 6px rgba(13,59,94,0.06)' }}>
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between',
      padding:'13px 18px', borderBottom:`1px solid ${C.borderL}`, background:'#FAFBFC' }}>
      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
        {icon && <span style={{ color:C.navy, opacity:0.65, display:'flex' }}>{icon}</span>}
        <span style={{ fontSize:13.5, fontWeight:700, color:C.t1 }}>{title}</span>
        {badge != null && (
          <span style={{ background:C.navyL, color:C.navy, padding:'2px 8px', borderRadius:999,
            fontSize:10.5, fontWeight:700, border:`1px solid rgba(13,59,94,0.12)` }}>{badge}</span>
        )}
      </div>
      {headerRight}
    </div>
    <div style={{ padding:18 }}>{children}</div>
  </div>
);

export const Err = ({ msg, onRetry }) => (
  <div style={{ padding:'32px 24px', textAlign:'center' }}>
    <div style={{ background:C.redL, border:`1px solid ${C.redBord}`, borderRadius:12,
      padding:'18px 22px', display:'inline-block', maxWidth:480, textAlign:'left' }}>
      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
        <FiAlertCircle size={15} style={{ color:C.redB }}/>
        <span style={{ fontWeight:700, color:C.redB, fontSize:13 }}>Could not load data</span>
      </div>
      <p style={{ color:'#7F1D1D', fontSize:12.5, margin:'0 0 12px' }}>{msg}</p>
      {onRetry && (
        <button onClick={onRetry} style={{ background:C.redB, color:C.white, border:'none', borderRadius:8,
          padding:'7px 16px', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>
          Retry
        </button>
      )}
    </div>
  </div>
);

export const Empty = ({ label = 'No data available' }) => (
  <div style={{ textAlign:'center', padding:'56px 24px' }}>
    <div style={{ width:52, height:52, borderRadius:'50%', background:C.navyL,
      display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px' }}>
      <FiCalendar size={22} style={{ color:C.navy, opacity:0.4 }}/>
    </div>
    <div style={{ fontSize:14, fontWeight:700, color:C.t1, marginBottom:6 }}>{label}</div>
    <div style={{ fontSize:12.5, color:C.t3 }}>Data will appear here once available</div>
  </div>
);

export const PBar = ({ label, value, total, color }) => {
  const pct = total > 0 ? Math.round((value / total) * 100) : 0;
  return (
    <div style={{ marginBottom:12 }}>
      <div style={{ display:'flex', justifyContent:'space-between', marginBottom:5 }}>
        <span style={{ fontSize:12.5, fontWeight:500, color:C.t2 }}>{label}</span>
        <div style={{ display:'flex', gap:8 }}>
          <span style={{ fontSize:13, fontWeight:700, color:C.t1 }}>{value}</span>
          <span style={{ fontSize:11, color:C.t4, minWidth:30, textAlign:'right' }}>{pct}%</span>
        </div>
      </div>
      <div style={{ height:6, background:'#F1F5F9', borderRadius:999, overflow:'hidden' }}>
        <div style={{ height:'100%', background:color, borderRadius:999, width:`${pct}%`,
          minWidth: value > 0 ? 4 : 0, transition:'width 0.7s ease-out' }}/>
      </div>
    </div>
  );
};

export const LoadingRows = ({ count = 5, h = 48 }) => (
  <div style={{ background:C.white, borderRadius:12, border:`1px solid ${C.border}`, padding:18 }}>
    <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
      {Array.from({ length: count }).map((_, i) => <Sh key={i} h={h}/>)}
    </div>
  </div>
);
